import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxArchive, faCircleDown, faCircleUp, faClipboardCheck, faShareNodes, faTrash, faEllipsisVertical, } from '@fortawesome/free-solid-svg-icons';
import { Modal } from '../UI/Modal';
import { Code } from '../UI/Code';
import { CardSkeleton } from '../UI/CardSkeleton';
import { useClickOutside } from '../../hooks/ui';
import { configService } from '../../services/config.service';
const { playServer } = await configService.appConfig;
export const CrosswordListItem = ({ crossword, onStatusUpdate, onDelete, }) => {
    const optionsRef = useRef(null);
    const [isOptionsOpen, setIsOptionsOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [copied, setCopied] = useState(false);
    // Use custom hook for options menu
    useClickOutside(optionsRef, () => {
        if (isOptionsOpen)
            setIsOptionsOpen(false);
    });
    /**
     * Handles successful code copy action
     */
    const handleCodeCopy = () => {
        setCopied(true);
    };
    const handleModalOpen = (event) => {
        event.preventDefault();
        setIsModalOpen(true);
        setCopied(false);
    };
    const handleModalClose = () => {
        setIsModalOpen(false);
    };
    const handleSubmissionsClick = (event) => {
        event.preventDefault();
        window.location.href = `/crosswords/${crossword.crosswordId}/submissions`;
    };
    const handleStatusUpdate = (event) => {
        event.preventDefault();
        onStatusUpdate(crossword.crosswordId, crossword.status === 'draft' ? 'published' : 'draft');
    };
    const handleDelete = (event) => {
        event.preventDefault();
        onDelete(crossword.crosswordId);
    };
    return crossword.loading ? (React.createElement(CardSkeleton, { kreeda: crossword })) : (React.createElement(React.Fragment, null,
        crossword.code && (React.createElement(Modal, { id: crossword.code, component: Code, componentProps: {
                id: crossword.code,
                link: `${playServer}?code=${crossword.code}`,
                copied,
                onCopy: handleCodeCopy,
            }, isOpen: isModalOpen, onClose: handleModalClose })),
        ' ',
        React.createElement(Link, { className: "activity-item", to: `/crosswords/${crossword.crosswordId}` },
            React.createElement("div", { className: "activity-header" },
                React.createElement("h3", null, crossword.name),
                React.createElement("div", { ref: optionsRef, className: "options-container" },
                    React.createElement("button", { className: "options-button", onClick: (event) => {
                            event.preventDefault();
                            setIsOptionsOpen(!isOptionsOpen);
                        } },
                        React.createElement(FontAwesomeIcon, { icon: faEllipsisVertical })),
                    React.createElement("div", { className: `options-menu ${isOptionsOpen ? 'show' : ''}` },
                        React.createElement("button", { onClick: handleSubmissionsClick },
                            React.createElement(FontAwesomeIcon, { icon: faClipboardCheck }),
                            "View Submissions"),
                        React.createElement("button", { onClick: (event) => {
                                event.preventDefault();
                            } },
                            React.createElement(FontAwesomeIcon, { icon: faBoxArchive }),
                            "Archive"),
                        React.createElement("button", { className: "delete-button", disabled: crossword.status !== 'draft', onClick: handleDelete },
                            React.createElement(FontAwesomeIcon, { icon: faTrash }),
                            "Delete")))),
            React.createElement("div", { className: "activity-meta" },
                crossword.duration && (React.createElement(React.Fragment, null,
                    React.createElement("span", null,
                        parseInt(crossword.duration) / 60,
                        " min"))),
                React.createElement("span", null,
                    crossword.wordsCount,
                    " word(s)"),
                React.createElement("span", null,
                    crossword.submissionsCount,
                    " submission(s)")),
            React.createElement("div", { className: "activity-actions" },
                React.createElement("button", { className: "btn--primary publish", onClick: handleStatusUpdate, disabled: crossword.wordsCount === 0 },
                    React.createElement(FontAwesomeIcon, { icon: crossword.status === 'draft' ? faCircleUp : faCircleDown }),
                    crossword.status === 'draft' ? 'Publish' : 'Unpublish'),
                React.createElement("button", { className: "btn--secondary share", value: crossword.code, onClick: handleModalOpen, disabled: crossword.status === 'draft' },
                    React.createElement(FontAwesomeIcon, { icon: faShareNodes }),
                    "Host")))));
};
